import {useAuth} from '@clerk/react';
import {useEffect, useRef} from 'react';
import {resetIntercomIdentity} from 'services/intercom';
import {clearPendoSession} from 'services/pendo';

/**
 * Clears the Intercom and Pendo identities when a Clerk session ends.
 *
 * Sign out mostly happens through Clerk's `<UserButton>`, which exposes no
 * callback, so we watch the auth state instead and reset on the signed-in ->
 * signed-out transition. This covers every sign out path, including the
 * expired-token redirect in `services/clerkAuth`.
 */
function IntercomIdentity() {
  const {isLoaded, isSignedIn} = useAuth();
  const wasSignedIn = useRef(false);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    if (isSignedIn) {
      wasSignedIn.current = true;
      return;
    }

    if (wasSignedIn.current) {
      wasSignedIn.current = false;
      resetIntercomIdentity();
      clearPendoSession();
    }
  }, [isLoaded, isSignedIn]);

  return null;
}

export default IntercomIdentity;
